import { useTranslator } from '@gandi/translate';
import { getTitleLabel } from '../CartWidget/DrawerContent/Body/helpers';
import { CategoryBadge } from './CategoryBadge';
import { getTheme } from './helpers';
import { jsx as _jsx } from "react/jsx-runtime";
export function ProductBadge({
  payload,
  process,
  productType
}) {
  const translator = useTranslator();
  const title = getTitleLabel({
    translator,
    productType,
    process,
    payload
  });
  return /*#__PURE__*/_jsx(CategoryBadge, {
    side: "right",
    size: "small",
    theme: getTheme(productType),
    children: title
  });
}